module.exports = __webpack_public_path__ + "media/images/subject_img/MATHEMATICS-66f5b1118a212e95c680b02a9b424dac.jpg";